import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";

export class HomeSliderViewModel {
  public sort_nr: number;
  public use_label: boolean;
  public get show_label(): boolean {
    return this.use_label && InternationalisationService.locale === "de" ? !!this.label_de : !!this.label_en;
  }
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public contentType: number;
  public contentId: number;
  public content_extra: string;
  public imagePhoto: string;
}

export class HomePrioTileViewModel {
  public sort_nr: number;
  public use_label: boolean;
  public get show_label(): boolean {
    return this.use_label && InternationalisationService.locale === "de" ? !!this.label_de : !!this.label_en;
  }
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public contentType: number;
  public contentId: number;
  public content_extra: string;
  public imagePhoto: string;
}

export class HomeTileViewModel {
  public sort_nr: number;
  public use_label: boolean;
  public get show_label(): boolean {
    return this.use_label && InternationalisationService.locale === "de" ? !!this.label_de : !!this.label_en;
  }
  public label_de: string;
  public label_en: string;
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.label_en) ? this.label_de : this.label_en;
  }
  public contentType: number;
  public contentId: number;
  public content_extra: string;
  public imagePhoto: string;
}
// Requests
// Slider
export class HomeSliderSyncModel extends SyncModel {
}
// Tile
export class HomeTileSyncModel extends SyncModel {
}
// PrioTile
export class HomePrioTileSyncModel extends SyncModel {
}

// Responses
class HomeBaseDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public release: boolean;
  public public: boolean;
  public sort_nr: number;
  public use_label: boolean;
  public use_content_label: boolean;
  public label_de: string;
  public label_en: string;
  public content_type: number;
  public content_id: number;
  public content_extra: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public get last_image_update_at(): Moment {
    return Utils.GetMomentFromInt(this.last_image_update_at_ymd, this.last_image_update_at_hms);
  }
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

// Home Slider
export class HomeSliderDataModel extends HomeBaseDataModel {
  public use_content_image: boolean;
}

export class HomeSliderSyncDataModel extends SyncDataModel {
  public home_sliders: HomeSliderDataModel[];
  public get models(): DataModel[] { return this.home_sliders; }
  public DeserializeType(): void {
    this._DeserializeType(HomeSliderDataModel);
  }
}

// Home PrioTile
export class HomePrioTileDataModel extends HomeBaseDataModel {
  public use_content_image: boolean;
}

export class HomePrioTileSyncDataModel extends SyncDataModel {
  public home_prio_tiles: HomePrioTileDataModel[];
  public get models(): DataModel[] { return this.home_prio_tiles; }
  public DeserializeType(): void {
    this._DeserializeType(HomePrioTileDataModel);
  }
}

// Home Tile
export class HomeTileDataModel extends HomeBaseDataModel {
}

export class HomeTileSyncDataModel extends SyncDataModel {
  public home_tiles: HomeTileDataModel[];
  public get models(): DataModel[] { return this.home_tiles; }
  public DeserializeType(): void {
    this._DeserializeType(HomeTileDataModel);
  }
}
